import React, { createContext, useState, useEffect } from "react";
import { createTheme } from "@mui/material/styles";
import packageJson from "../../package.json";
// import { SettingsContext } from "./settings-context";

export const MyThemeContext = createContext();

const darkTheme = createTheme({
	palette: {
		mode: "dark",
	},
	typography: {
		h5: {
			fontSize: "1.3rem",
		},
		h6: {
			fontSize: "1rem",
		},
	},
	components: {
		MuiSelect: {
			styleOverrides: {
				select: {
					padding: "5px 6px",
				},
			},
		},
	},
});

const lightTheme = createTheme({
	palette: {
		mode: "light",
	},
	typography: {
		h5: {
			fontSize: "1.3rem",
		},
		h6: {
			fontSize: "1rem",
		},
	},
	components: {
		MuiSelect: {
			styleOverrides: {
				select: {
					padding: "5px 6px",
				},
			},
		},
	},
});

export const MyThemeProvider = (props) => {
	const [themeState, setThemeState] = useState(JSON.parse(localStorage.getItem('Q8__verif_scores__themeState')) || false);
	const [showHeader, setShowHeader] = useState(true);

	const [loading, setLoading] = useState(false);
	
	const FRONT_END_NAME = "Q8 - Verif Scores"
	const FRONT_END_VERSION = packageJson.version

	useEffect(() => {
		localStorage.setItem('Q8__verif_scores__themeState', JSON.stringify(themeState));
	}, [themeState]);

	const themeContext = themeState ? darkTheme : lightTheme;

	// console.log("themeContext", themeContext);

	const value = {
		themeState,
		themeContext,
		setThemeState,
		showHeader,
		setShowHeader,
		loading,
		setLoading,
		FRONT_END_NAME,
		FRONT_END_VERSION,
	};

	return <MyThemeContext.Provider value={value}>{props.children}</MyThemeContext.Provider>;
};
